module.exports = __webpack_public_path__ + "static/media/intramark3.be11325f.png";